/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.CreateGroupResponse,
  CreateGroup: (params: vp.CreateGroupRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCreateGroup: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCreateGroup, setShouldCreateGroup] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CreateGroupRequest>({
    GroupName: "",
    Description: "",
    Service: "",
    Currency: "",
  });
  const [response, setResponse] = useState<vp.CreateGroupResponse>({
    Success: false,
    ErrorMessage: '',
    GroupID: '',
  });

  useEffect(() => {
    if (!shouldCreateGroup) return () => {};

    const PostCreateGroup = async () => {
      setDataFetchingInfo(true, 'creating group', 'fullScreen');
      const res = await api.postCreateGroup(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCreateGroup) void PostCreateGroup();
    setShouldCreateGroup(false);
    return () => {
      source.cancel();
    };
  }, [shouldCreateGroup]);

  return [
    response,
    (_params: vp.CreateGroupRequest) => {
      setParams(_params);
      setShouldCreateGroup(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        GroupID: '',
      });
      setShouldCreateGroup(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCreateGroup);